<div class="cultureCard-list_container"  [ngClass]="{'is-mobile-view': isMobileView}">
  @if (isLoading) {
    <!-- we create a dummy array of 6 elements, thus creating 6 cards of loading state -->
    @for (_ of [].constructor(6); track $index) {
    <app-culture-card
      class="cultureCard-list_card"
      [isLoading]="isLoading"
    ></app-culture-card>
  } } @else { 
  @for (culture of sortedFamiliesAggData; track culture.cultureId) {
    <app-culture-card
      class="cultureCard-list_card"
      [ngClass]="{'is-mobile-view': isMobileView}"
      [familyName]="culture.name"
      [cultureScore]="culture.score"
      [impact]="culture.impact"
      [cultuerIcon]="culture.imageUrl"
      [isSelected]="selectedCultureId == culture.cultureId"
      [isLoading]="isLoading"
      (onCultureSelected)="onCultureSelectedHandler(culture.cultureId)"
      
    ></app-culture-card>
  } }
</div>
